import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import _ from 'lodash';
import DatePicker from 'react-datepicker';

import Table from '../../../components/table/Table';
import ModalLoggerInformation from './modalLoggerInformation';

import ROUTES from '../../../config/routes';

import { getAllLogs } from '../../../app/store/actions/logger';

class DevelopLoggerList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];

    this.state = {
      page: 0,
      pages: 0,
      totalDataLength: 0,
      headersData: '',
      bodyData: '',
      openInformationModal: false,
      date: '',
    };

    this.defaultSorted = [
      {
        id: 'createdAt',
        desc: true,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE56' /* Detalhes */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        minWidth: 90,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-primary btn-xs"
              onClick={() => this.selectRegistryInformation(row.original)}
            >
              <span className="d-flex align-items-center text-start">
                {I18n.t('BEE56' /* Detalhes */)}
              </span>
            </button>
          </div>
        ),
      }, {
        Header: I18n.t('BEE623' /* Login */),
        accessor: 'user.login',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4769' /* IP */),
        accessor: 'ip',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4770' /* URL */),
        accessor: 'url',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'type',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4768' /* Método */),
        accessor: 'method',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE578' /* Data Criação */),
        accessor: 'createdAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
    }
  };

  getAllLogs = async () => {
    const data = await this.props.getAllLogs({
      page: this.page,
      pageSize: this.pageSize,
      sorted: this.sorted,
      filtered: this.filtered,
    });

    this.setState({ pages: data.pages, totalDataLength: data.totalDataLength });
  };

  parseLogData = (data) => {
    if (!data) {
      return '';
    }

    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  handleDateChange = (date) => {
    this.setState({ date });
  };

  filterDate = ({ onChange }) => (
    <DatePicker
      selected={this.state.date}
      onChange={(date) => {
        this.handleDateChange(date);
        onChange(date);
      }}
      dateFormat="dd/MM/yyyy"
      withPortal
      isClearable
    />
  );

  selectRegistryInformation = (selectedLine) => {
    this.setState({
      headersData: this.parseLogData(selectedLine.headers),
      bodyData: this.parseLogData(selectedLine.body),
      openInformationModal: true,
    });
  };

  closeModal = () => {
    this.setState({
      openInformationModal: false,
      headersData: '',
      bodyData: '',
    });
  };

  render() {
    const { logs = [] } = this.props;
    const {
      page, pages, totalDataLength, headersData, bodyData, openInformationModal,
    } = this.state;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE48' /* Desenvolvedor */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4762' /* Logger */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          headerTitle={I18n.t('BEE4762' /* Logger */)}
          wikiHelp={ROUTES.DEVELOP_LOGGER_HELP}
          panelHeaderProps={{
            onClickReload: this.getAllLogs,
          }}
          filterable
          data={logs}
          totalDataLength={totalDataLength}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual
          pages={pages}
          page={(page)
            || ((!this.state.firstRun
              && this.props.location.state
              && this.props.location.state.dice
              && this.props.location.state.dice.page)
              ? this.props.location.state.dice.page : page)}
          onPageChange={(p) => ((p >= 0) ? this.setState({ page: p }) : this.setState({ page: 0 }))}
          onFetchData={(state) => {
            let pag;
            if (state.page) {
              pag = state.page;
            } else if (!this.state.firstRun
              && this.props.location.state
              && this.props.location.state.dice
              && this.props.location.state.dice.page) {
              pag = this.props.location.state.dice.page;
            } else {
              pag = state.page;
            }
            this.setState({ page: pag });
            this.page = pag;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getAllLogs();
          }}
        />
        <ModalLoggerInformation
          closeModal={this.closeModal}
          headersData={headersData}
          bodyData={bodyData}
          openInformationModal={openInformationModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  logs: state.logger && state.logger.logs,
});

const mapDispatchToProps = (dispatch) => ({
  getAllLogs: (tableParams) => dispatch(getAllLogs(tableParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DevelopLoggerList));
